<div class="row">
   <div class="col-md-12">
      <div class="card">
         <div class="row">
            <div class="col-md-8">
               <h5 class="headingValue">Permission For Temporary Registration(PTR) Application</h5>
               &nbsp;&nbsp;
            </div>
            <div class="col-md-4 text-right">
               <button *ngIf="userDetails?.statusId===9 && userDetails?.maxAssignedToUserIdFlag" type="button" class="globalBtn forwardBtn" data-toggle="modal" style="width:140px"
                  data-target="#seekClarificationCandidateModal">Resubmit</button>&nbsp;&nbsp;
               <button type="submit" class="btn btn-primary" style="float: right;" (click)="back()">
               <span><i class="fas fa-angle-left"></i></span>&nbsp;Back</button>
            </div>
         </div>
         <hr>
         <form id="guruId" [formGroup]="formGroupId" enctype="multipart/form-data" role="form" autocomplete="off"
            class="has-validation-callback">
            <div class="bt-tab-content-main">
               <div class="tab-content">
                  <div id="signin">
                     <div class="col-lg-12 mt-4">
                        <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Applicant Details</h5>
                        <hr class="fqsr-certificate-hr mt-1">
                        <div class="row" *ngIf="userDetails?.applicationId !== null && userDetails?.applicationId !== ''">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="phoneNo" class="required">Application Id <span
                                    class="text-danger">:</span>&nbsp; {{userDetails?.applicationId}}</label>
                              </div>
                           </div>
                        </div>
                        <div class="row"
                           *ngIf="userDetails?.certificateRegistration!=null && userDetails?.certificateRegistration!=''">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="phoneNo" class="required">Registration Number <span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.certificateRegistration}}</label>
                              </div>
                           </div>
                        </div>
                        <!--UPLOAD REGISTRATION BY SUGAND-->
                        <div class="row" *ngIf="userDetails?.documentaryProof!=null && userDetails?.documentaryProof!=''">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="phoneNo" class="required">Uploaded Registration Certificate </label>
                                 <br>
                                 <a class="downloadView"
                                 (click)="viewDocuments(userDetails?.documentaryProof, userDetails?.documentaryProof?.split('/').pop())"
                                 *ngIf="userDetails?.documentaryProof !='' && userDetails?.documentaryProof !=undefined">
                                 <span><i class="far fa-file-alt docIcons"></i>
                                 {{userDetails?.documentaryProof?.split('/').pop()}}</span>
                                 <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
                                 </a>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="grivFirstName" class="required">Applicant Name <span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.name}}</label>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="grivFirstName" class="required">Email<span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.userEmail}}</label>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="phoneNo" class="required">Mobile Number <span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.mobileNumber}}</label>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="form-group"
                                 *ngIf="userDetails?.landlineNumber!=null && userDetails?.landlineNumber!=''">
                                 <label for="phoneNo" class="required">Landline Number <span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.landlineNumber}}</label>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-12 mt-4">
                        <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Address</h5>
                        <hr class="fqsr-certificate-hr mt-1">
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label class="required">{{userDetails?.addressLine1}}<span
                                    *ngIf="userDetails?.addressLine1 !== ''">,</span><br>
                                 {{userDetails?.addressLine2}}<span
                                    *ngIf="userDetails?.addressLine2 !== ''">,</span><br>
                                 {{userDetails?.cityName}}<span *ngIf="userDetails?.cityName !== ''">,</span>
                                 {{userDetails?.stateName}}<span *ngIf="userDetails?.stateName !== ''">,</span>
                                 {{userDetails?.country}} <span *ngIf="userDetails?.country !== ''">-</span>
                                 {{userDetails?.pinCode}}<span *ngIf="userDetails?.pinCode !== ''">.</span></label>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="col-lg-12 mt-4">
                        <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Purpose of Inviting Foreign Dentist</h5>
                        <hr class="fqsr-certificate-hr mt-1">
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <textarea class="form-control" rows="5"
                                    placeholder="Purpose of Conducting/ Inviting Foreign Dentist *"
                                    formControlName="purposeConducting" readonly></textarea>
                              </div>
                           </div>
                        </div>
                        <br>
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="startDate" class="required"> Start Date <span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.startDate | date :
                                 'dd-MM-yyyy'}}</label>
                              </div>
                           </div>
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="endDate" class="required"> End Date <span
                                    class="text-danger">:</span>&nbsp;{{userDetails?.endDate | date :
                                 'dd-MM-yyyy'}}</label>
                              </div>
                           </div>
                        </div>
                        <div class="row">
                           <div class="col-md-6">
                              <div class="form-group">
                                 <label for="venueProgram" class="required">Venue of the Program <span
                                    class="text-danger"></span></label>
                                 <textarea class="form-control" rows="5" placeholder="Venue of the Program *"
                                    formControlName="venueProgram" readonly></textarea>
                              </div>
                           </div>
                        </div>
                        <hr class="fqsr-certificate-hr mt-1">
                     </div>
                     <div class="col-lg-12 mt-4">
                        <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Invitee Information</h5>
                        <hr class="fqsr-certificate-hr mt-1">
         <form [formGroup]="form" novalidate>
         <div formArrayName="itemRows">
         <div class="row" *ngFor="let item of userDetails?.inviteeList;let i=index">
         <div class="col-lg-12 mt-1">
         <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Invitee {{i+1}}</h5>
         <hr class="fqsr-certificate-hr mt-1">
         </div>
         <div class="col-md-6"
            *ngIf="item.inviteecertificateRegistration!=null && item.inviteecertificateRegistration!=''">
         <div class="form-group" [formGroupName]="i">
         <label for="inviteecertificateRegistration" class="required">Registration Number
         <span
            class="text-danger">:</span>&nbsp;{{item.inviteecertificateRegistration}}</label>
         </div>
         </div>
         <!--UPLOAD INVITEE REGISTRATION BY SUGAND-->
         <div class="col-md-6">
         <div class="form-group">
         </div>
         </div>
         <div class="col-md-6"
            *ngIf="item.inviteedocumentaryProof!=null && item.inviteedocumentaryProof!=''">
         <div class="form-group" [formGroupName]="i">
         <label for="phoneNo" class="required">Uploaded Registration Certificate </label>
         <br>
         <a class="downloadView"
         (click)="viewDocuments(item.inviteedocumentaryProof, item.inviteedocumentaryProof?.split('/').pop())"
         *ngIf="item.inviteedocumentaryProof !='' && item.inviteedocumentaryProof !=undefined">
         <span><i class="far fa-file-alt docIcons"></i>
         {{item.inviteedocumentaryProof?.split('/').pop()}}</span>
         <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
         </a>
         </div>
         </div>
         <div class="col-md-6">
         <div class="form-group">
         </div>
         </div>
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label for="inviteename" class="required">Invitee Name <span
            class="text-danger">:</span>&nbsp;{{item.inviteeName}}</label>
         </div>
         </div>
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label for="inviteeemail" class="required">Email<span
            class="text-danger">:</span>&nbsp;{{item.userEmail}}</label>
         </div>
         </div>
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label for="phoneNo" class="required">Mobile Number <span
            class="text-danger">:</span>&nbsp;{{item.mobileNumber}}</label>
         </div>
         </div>
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label for="councilName" class="required">Council Name <span
            class="text-danger">:</span>&nbsp;{{item.councilName}}</label>
         </div>
         </div>
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label for="validUpto" class="required">Valid Upto <span
            class="text-danger">:</span>&nbsp;{{item.validUpto | date :'dd-MM-yyyy'}}</label>
         </div>
         </div>
         <div class="col-lg-12 mt-4">
         <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Invitee Address</h5>
         <hr class="fqsr-certificate-hr mt-1">
         <div class="row">
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label class="required">{{item.addressLine1}}<span
            *ngIf="item.addressLine1 !== ''">,</span><br>
         {{item.addressLine2}}<span *ngIf="item.addressLine2 !== ''">,</span><br>
         {{item.cityName}}<span *ngIf="item.cityName !== ''">,</span>
         {{item.stateName}}<span *ngIf="item.stateName !== ''">,</span>
         {{item.countryName}} <span *ngIf="item.countryName !== ''">-</span>
         {{item.pinCode}}<span *ngIf="item.pinCode !== ''">.</span></label>
         </div>
         </div>
         </div>
         </div>
         <div class="col-lg-12 mt-4">
         <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Uploaded Complete Biodata
         </h5>
         <hr class="fqsr-certificate-hr mt-1">
         <div class="row">
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label class="required">Complete Biodata </label>
         <br>
         <span><i class="far fa-file-alt docIcons"></i>
         {{item.bioData?.split('/').pop()}}</span>
         <a class="downloadView"
         (click)="viewDocuments(item.bioData, item.bioData?.split('/').pop())"
         *ngIf="item.bioData !='' && item.bioData !=undefined">
         <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
         </a>
         </div>
         </div>
         </div>
         </div>
         <div class="col-lg-12 mt-4" *ngIf="item.briefBio!=null && item.briefBio!=''">
         <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Self Declaration Documents
         </h5>
         <hr class="fqsr-certificate-hr mt-1">
         <div class="row">
         <div class="col-md-6">
         <div class="form-group" [formGroupName]="i">
         <label for="briefBio" class="required">Uploaded Self Declaration </label>
         <br>
         <a class="downloadView"
         (click)="viewDocuments(item.briefBio, item.briefBio?.split('/').pop())"
         *ngIf="item.briefBio !='' && item.briefBio !=undefined">
         <span><i class="far fa-file-alt docIcons"></i>
         {{item.briefBio?.split('/').pop()}}</span>
         <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
         </a>
         </div>
         </div>
         </div>
         </div>
         <hr class="fqsr-certificate-hr mt-1">
         </div>
         </div>
         </form>
         </div>
         <div class="col-lg-12 mt-4"
            *ngIf="userDetails?.declarationContent!=null && userDetails?.declarationContent!=''">
         <h5 class="mt-3 mb-0 fqsr-certificate-h5 headingValue">Declaration Documents</h5>
         <hr class="fqsr-certificate-hr mt-1">
         <!--DECLARATION DOCUMENT BY SUGAND-->
         <div class="row">
         <div class="col-md-6">
         <div class="form-group">
         <label for="phoneNo" class="required">Delaration Content </label>
         <br>
         <a class="downloadView"
         (click)="viewDocuments(userDetails?.declarationContent, userDetails?.declarationContent?.split('/').pop())"
         *ngIf="userDetails?.declarationContent !='' && userDetails?.declarationContent !=undefined">
         <span><i class="far fa-file-alt docIcons"></i>
         {{userDetails?.declarationContent?.split('/').pop()}}</span>
         <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
         </a>
         </div>
         </div>
         </div>
         </div>
         <hr>
         </div>
         </div>
         <div class="clearfix"></div>
         </div>
         <div class="row" style="padding-left: 15px;padding-bottom: 10px;font-size: large;">
            <h5 class="headingValue">Payment Information</h5>
         </div>
         <div class="row">
            <div class="col-md-4">
               <p>Payment Reference Number: </p>
            </div>
            <div class="col-md-8">
               <p>{{userDetails?.utrNo}}</p>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <p>Transaction Amount: </p>
            </div>
            <div class="col-md-8">
               <p>{{userDetails?.transactionAmount}}</p>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <p>Payment Status: </p>
            </div>
            <div class="col-md-8">
               <p>{{userDetails?.paymentStatus}}</p>
            </div>
         </div>
         <div class="row">
            <div class="col-md-4">
               <p>Payment Transaction Date: </p>
            </div>
            <div class="col-md-8">
               <p>{{userDetails?.formattedTransactionDate}}</p>
            </div>
         </div>
         <div class="row" *ngIf="userDetails?.ptrWorkflowsDTOList.length > 0">
            <div class="col-md-12">
                <h5 class="headingValue"> Seek Clarification Comment </h5> <br>    
                <div *ngFor="let item of userDetails?.ptrWorkflowsDTOList; let i=index">
                     <p style="font-size: 12px;">
                        {{item.createdDate | date : 'dd-MM-yyyy hh:mm a'}}
                    </p>
                    <p style="margin-bottom: 4px;">
                        {{(item.comments !==null && item.comments !==" ") ?(item.comments):''}}
                    </p>  
                </div>
            </div>
        </div><br>
        <div class="row" *ngIf="userDetails?.ptrWorkflowsReSubDTOList.length > 0">
         <div class="col-md-12">
             <h5 class="headingValue"> Application Resubmitted Comment </h5> <br>    
             <div *ngFor="let item of userDetails?.ptrWorkflowsReSubDTOList; let i=index">
                  <p style="font-size: 12px;">
                     {{item.createdDate | date : 'dd-MM-yyyy hh:mm a'}}
                 </p>
                 <p style="margin-bottom: 4px;">
                     {{(item.comments !==null && item.comments !==" ") ?(item.comments):''}}
                 </p>  
             </div>
         </div>
     </div>
         </form>
      </div>
   </div>
</div>
<!-- Seek Clarification Candidate Modal starts -->
<div class="modal fade" id="seekClarificationCandidateModal" role="dialog">
   <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
         <div class="modal-header">
            <h4 class="modal-title headingValue">Resubmit Application</h4>
            <button type="button" class="close" #seekClarificationCandidateDismissModal data-dismiss="modal"
            (click)="reset()">&times;</button>
         </div>
         <div class="modal-body">
            <form [formGroup]="seekClarificationForm">
               <div class="row">
                  <label>Comments <span class="aseticcolor">*</span></label>
                  <textarea class="form-control" rows="5" cols="20" placeholder="Write Comments"
                     formControlName="comment" maxlength="2000"></textarea>
               </div>
               <div *ngIf=" submitted && re.comment.errors" class="invalid-feedback">
                  <div *ngIf=" submitted && re.comment.errors.required">
                     Comments Required
                  </div>
               </div>
            </form>
         </div>
         <div class="modal-footer">
            <button type="button" class="globalBtn acceptBtn" [disabled]="!seekClarificationForm.valid"
            (click)="ptrApplicationReSubmit()">Send</button>
            <button type="button" class="globalBtn clearBtn" #dismissModal
            (click)="reset()">Reset</button>
         </div>
      </div>
   </div>
</div>
<!-- Seek Clarification Candidate Modal ends -->